import { useEffect, useRef } from 'react';
import { useProducts } from '../../contexts/ProductsContext';
import { useInventory } from '../../contexts/InventoryContext';

/**
 * Sincroniza nome, preço e estoque inicial nos documentos do Firestore (inventory).
 * Na primeira visita após deploy, define 10 unidades por tamanho (uma vez só).
 */
const InventoryNameSync = () => {
  const { products, loading } = useProducts();
  const { syncProductInventory } = useInventory();
  const synced = useRef(false);

  useEffect(() => {
    if (loading || !products.length || synced.current) return;

    synced.current = true;
    products.forEach((product) => {
      syncProductInventory(product);
    });
  }, [loading, products, syncProductInventory]);

  return null;
};

export default InventoryNameSync;
